<div class="py-5">
  <div>
    <h2 class="mb-4">Your Billing Information</h2>
    @if (paymentInfo) {
      <strong>
        {{ paymentInfo.card.brand | titlecase }}
        {{ 'xxxx xxxx xxxx ' + paymentInfo.card.last4 }}
        {{ paymentInfo.card.exp_month + '/' + paymentInfo.card.exp_year}}
      </strong>
    }
    <a class="btn btn-sm btn-primary d-inline-block ml-3" (click)="open(content)">Update</a>
  </div>

  <hr>

    <div>
      <h2 class="mb-4">Transaction History</h2>
      @if (charges.length === 0) {
        <h6 class="mb-4">No charges yet</h6>
      }
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Order #</th>
            <th scope="col">Date</th>
            <th scope="col">Card</th>
            <th scope="col">Amount</th>
          </tr>
        </thead>
        <tbody>
          @for (charge of charges; track charge) {
            <tr>
              <th scope="row"><a [href]="charge.receipt_url" target="_blank">{{ charge.receipt_number }}</a></th>
              <td>{{ (charge.created * 1000) | date }}</td>
              <td><strong>{{ charge.payment_method_details.card.brand | titlecase }}</strong>
            {{ ' ****' + charge.payment_method_details.card.last4 }}</td>
            <td>{{ (charge.amount / 100) | currency }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <hr>

    <a href="https://www.muchsmarter.com/cancel-account" target="_blank">
    Cancel Subscription</a>
  </div>

  <ng-template #loading>
    <app-spinner></app-spinner>
  </ng-template>

  <ng-template #content let-modal>
    <app-stripe-card (tokenReady)="updateBillingInfo($event)"></app-stripe-card>
  </ng-template>
